import service from '@/utils/request'

export const getVipConfigList = (data) => {
  return service({
    url: '/uVip/getVipConfigList2',
    method: 'post',
    data
  })
}

export const updateVipConfig = (data) => {
  return service({
    url: '/uVip/updateVipConfig2',
    method: 'post',
    data
  })
}

export const addVipConfig = (data) => {
  return service({
    url: '/uVip/addVipConfig2',
    method: 'post',
    data
  })
}

export const getSysConfigList = (data) => {
  return service({
    url: '/uMarket/sys/getSysConfigList',
    method: 'post',
    data
  })
}

export const updateSysConfig = (data) => {
  return service({
    url: '/uMarket/sys/updateSysConfig',
    method: 'post',
    data
  })
}

export const delVipConfig = (data) => {
  return service({
    url: '/uVip/delVipConfig2',
    method: 'post',
    data
  })
}

export const getVipSeasonList = (data) => {
  return service({
    url: '/uVip/getVipSeasonList',
    method: 'post',
    data
  })
}

export const addVipSeason = (data) => {
  return service({
    url: '/uVip/addVipSeason',
    method: 'post',
    data
  })
}

export const updateVipSeason = (data) => {
  return service({
    url: '/uVip/updateVipSeason',
    method: 'post',
    data
  })
}

export const delVipSeason = (data) => {
  return service({
    url: '/uVip/delVipSeason',
    method: 'post',
    data
  })
}



